<template>
  <div class="absolute left-1/2 transform -translate-x-1/2 flex items-center">
    <!-- Logo -->
    <div>
      <p>portal</p>
    </div>
  </div>
</template>

<script setup>
</script>
